const MOJIBAKE_HINT_RE = /[ÃÂðï�\u0080-\u009F]/;

export const decodeUtf8Mojibake = (value) => {
  const text = String(value ?? "");
  if (!text) return text;
  if (!MOJIBAKE_HINT_RE.test(text)) return text;

  try {
    const bytes = Uint8Array.from(
      Array.from(text, (character) => character.charCodeAt(0) & 0xff),
    );
    const decoded = new TextDecoder("utf-8").decode(bytes);
    return decoded || text;
  } catch {
    return text;
  }
};

